import { GridColumnType } from "../../../../components/molGrid/libs/data/gridColumnType";

export const clientValuationGridConfig = {
  isRowSelectable: true,
  allowEdit: false,
  hasChildGridTable: false,
  columns: [
    {
      name: "Val ID",
      fieldName: "valID",
      colStyle: {
        textAlign: "left",
        width: "5%",
      },
      allowShort: true,
    },
    {
      name: "Name",
      fieldName: "valName",
      colStyle: {
        textAlign: "left",
        width: "17%",
      },
      allowShort: true,
    },
    {
      name: "Plan Year Begin",
      fieldName: "planYearBegin",
      colStyle: {
        textAlign: "center",
        width: "10%",
      },
      colType:GridColumnType.DATE,
      allowShort: true,
      colSettings :{
        format:"MM/DD/YYYY"
      }
    },
    {
      name: "Plan Year End",
      fieldName: "planYearEnd",
      colType:GridColumnType.DATE,
      colStyle: {
        textAlign: "center",
        width: "10%",
      },
      allowShort: true,
      colSettings :{
        format:"MM/DD/YYYY"
      }
    },
    {
      name: "Word Documents",
      fieldName: "wordDocPathAndName",
      colStyle: {
        textAlign: "left",
        width: "23%",
      },
      allowShort: false,
    },
    {
      name: "Report Template Name",
      fieldName: "reportTemplateName",
      colStyle: {
        textAlign: "left",
        width: "17%",
      },
      allowShort: false,
    },
    {
      name: "Report Type",
      fieldName: "reportType",
      colStyle: {
        textAlign: "left",
        width: "12%",
      },
      allowShort: false,
    },
    
    {
      name: "Action",
      colType: GridColumnType.ACTION,
      defaultAction: {
        allowEdit: false,
        allowDelete: true,
      },
      customAction: [
        {
            name: "VIEW",
            iconClass: 'lsicon:view-outline',
        },
    ],
      
      colStyle: {
        width: "6%",
      },
      allowShort: false,
    },
  ],
};
